import useForm from 'hooks/useForm'
import moment from 'moment'
import { useEffect, useState } from 'react'

import ConfirmationDialog from '../ConfirmationDialog/index'
import Datepicker from '../Datepicker/index'
import styles from './MarkAsPaid.module.scss'

const MarkAsPaid = ({ title, handleSubmit, handleClose }) => {
  const useFormData = useForm({
    paymentMethod: 'Unknown',
    paymentConfirmationCode: '',
    paymentClearedOn: null,
    paymentAmount: 0
  })

  // eslint-disable-next-line no-unused-vars
  const [values, _handleChange, setValue] = useFormData
  const [isValidated, setValidated] = useState(false)

  useEffect(() => {
    const { paymentMethod, paymentClearedOn, paymentConfirmationCode, paymentAmount } =
      values

    if (
      paymentMethod !== 'Unknown' &&
      paymentClearedOn &&
      paymentConfirmationCode &&
      paymentAmount
    ) {
      setValidated(true)
    } else {
      setValidated(false)
    }
  }, [values])

  return (
    <ConfirmationDialog
      title={title}
      positiveMessage="Add new payment"
      isButtonDisabled={!isValidated}
      onConfirm={() => handleSubmit(values)}
      onClose={handleClose}
    >
      <div className={styles.container}>
        <Select
          name="paymentMethod"
          label="Select a payment method"
          useForm={useFormData}
          defaultVal="Unknown"
        >
          {Object.keys(paymentMethods).map(k => (
            <option value={k} key={k}>
              {paymentMethods[k]}
            </option>
          ))}
        </Select>
        <Input
          name="paymentAmount"
          label="Payment amount"
          useForm={useFormData}
          className={styles.paymentAmountInput}
        />
        <div className={styles.datepickerContainer}>
          <Datepicker
            className={styles.datepicker}
            selected={
              values.paymentClearedOn ? moment(values.paymentClearedOn).toDate() : null
            }
            onChange={date =>
              setValue({ paymentClearedOn: moment(date).format('YYYY-MM-DD') })
            }
            placeholderText="Click to select a date"
            maxDate={moment().add(7, 'days').toDate()}
          />
        </div>
        <Input
          name="paymentConfirmationCode"
          label="Conf #"
          useForm={useFormData}
          autoComplete="off"
        />
        <Textarea name="paymentNotes" label="Notes (optional)" useForm={useFormData} />
      </div>
    </ConfirmationDialog>
  )
}

const Input = ({ label, useForm, name, autoComplete, className }) => (
  <div className={styles.inputContainer}>
    <label>{label}</label>
    <input
      name={name}
      onChange={useForm[1]}
      value={useForm[0][name]}
      autoComplete={autoComplete}
      className={className}
    />
  </div>
)

const Textarea = ({ label, useForm, name }) => (
  <div className={styles.inputContainer}>
    <label>{label}</label>
    <textarea name={name} onChange={useForm[1]} value={useForm[0][name]} />
  </div>
)

const Select = ({ label, name, children, defaultVal, useForm }) => (
  <select onChange={useForm[1]} value={useForm[0][name]} name={name}>
    <option value={defaultVal} disabled>
      {label}
    </option>
    {children}
  </select>
)

const paymentMethods = {
  Check: 'Check',
  CreditCard: 'Credit card',
  WireTransfer: 'Wire transfer',
  ACH: 'ACH'
}

export default MarkAsPaid
